import { IPressureIconProps } from '../components/Icons/WeatherIcons/AirPressure/AirPressureIcon';

export const getPressureIconValue = (value: number): IPressureIconProps['value'] => {
  // eslint-disable-next-line no-magic-numbers
  if (value < 100500) {
    return 'LOW';
  }
  // eslint-disable-next-line no-magic-numbers
  if (value < 101500) {
    return 'MEDIUM';
  }
  return 'HIGH';
};
